import React from "react";
import { Link } from "react-router-dom";
import linkStyles from "../../../assets/css/modules/shared/link.css";
import ContactusForPayment from "../../../components/myprofile/ContactusForPayment";
import Store from "../../../content/Store";

export default function({
  linkTo,
  styles,
  iconSrc,
  title,
  subTitle,
  InfoText,
  isUpdated,
  info,
  linkMethod,
  linkText,
  isDisabled,
  featureFlagEP,
  IsFormat2,
  IsHealthSelect,
  isCrestDowntime,
  IsOverageDependant,
  id,
  MFATitle,
  MFAText,
  isMyprofile
}) {
  const linkProps = {
    to: linkTo ? linkTo : "#",
    className: isDisabled?
    ( InfoText?
      [styles.actionLinkInfo, linkStyles.disabled].join(" ") :
       [styles.actionLink, linkStyles.disabled].join(" "))
      : InfoText? styles.actionLinkInfo: styles.actionLink,
    onClick:
      linkMethod && !isDisabled
        ? linkMethod
        : e => {
            isDisabled && e.preventDefault();
          }
  };

  return (
    <div className={styles.summaryDetailWithIcon}>
      <i className={iconSrc} />
      <div className={styles.summaryDetailTitle}>{title}</div>
      
      <div className={styles.desc + " " + styles.defaultStyle}>
      {subTitle?<div >{subTitle}</div>:null}
        <div className={isMyprofile?"":"d-inline-block"} >
          {isUpdated ? (
            <i className="icon-check-green float-right ml-2 mt-1" />
          ) : null}
          {info} 
          {window?.axa?.features?.MFAFeature === "true" && 
          <React.Fragment>
            <br/>
            {MFATitle}<br />
            {MFAText}
          </React.Fragment>}
        </div>
      </div>
          {(featureFlagEP === true &&  !isDisabled && ((!IsFormat2 || IsHealthSelect)  && !InfoText)) || (isCrestDowntime && IsFormat2) ?
    
     
     (<a
      href={linkTo}
      target="_blank"
      rel="noopener"
      className={linkProps.className}
      id={linkText === Store.MyProfile.MemberBank.LinkTextAdd || linkText === Store.MyProfile.MemberBank.LinkTextUpdate ? id: ""}
    >
      {linkText} <span className="ml-2">➔</span>
    </a>)
      :
      
      linkTo || linkMethod ? (
        <Link id={linkText === Store.MyProfile.MemberBank.LinkTextAdd || linkText === Store.MyProfile.MemberBank.LinkTextUpdate ? id: ""} {...linkProps}>
          {linkText} <span className="ml-2">➔</span>
        </Link>
      ) : null
      
      }
   
      {!IsOverageDependant ?InfoText?<ContactusForPayment/>:null:null}
     
    </div>
  );
}
